import CaseAnalysisContainer from './CaseAnalysisContainer'

export default CaseAnalysisContainer
